import { Link } from "react-router-dom";

/** Avida brand mark — uses the real logo image. */
export default function AvidaMark({
  size = "sm",            // "xs" | "sm" | "md" | "lg"
  withWordmark = true,    // false = icon-only
  className = "",
  asLink = false,
}) {
  const SIZE = {
    xs: { box: "h-5",  name: "text-[11px]" },
    sm: { box: "h-7",  name: "text-sm"     },
    md: { box: "h-10", name: "text-base"   },
    lg: { box: "h-16", name: "text-lg"     },
  }[size] || { box: "h-7", name: "text-sm" };

  const Inner = (
    <div className={`inline-flex items-center gap-2 ${className}`}>
      <img
        src="/brand/avida-logo.png"
        alt="Avida Personal Care"
        className={`${SIZE.box} w-auto select-none`}
        draggable={false}
      />
      {withWordmark && (
        <span className={`${SIZE.name} font-extrabold tracking-tight text-[#15233B] hidden sm:inline`}>
          Avida
        </span>
      )}
    </div>
  );

  if (asLink) {
    return (
      <Link to="/" data-testid="avida-mark" className="hover:opacity-80 transition-opacity">
        {Inner}
      </Link>
    );
  }
  return <span data-testid="avida-mark">{Inner}</span>;
}
